const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&");

const isLocalHost = () => {
  const { hostname } = window.location;
  return hostname === "localhost" || hostname === "127.0.0.1";
};

async function postNetlify(payload) {
  const response = await fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encode(payload),
  });

  if (!response.ok) {
    throw new Error("Could not join the waitlist");
  }
}

async function postInbox({ email, pincode, city }) {
  const response = await fetch("https://formsubmit.co/ajax/info@eldykare.com", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      email,
      pincode,
      city,
      _subject: `EldyCare city request — ${city}`,
      _captcha: "false",
    }),
  });

  if (!response.ok) {
    throw new Error("Could not send city request");
  }
}

export async function submitWaitlist({ email, pincode, city }) {
  const payload = {
    "form-name": "waitlist",
    email,
    pincode,
    city,
  };

  const jobs = [postInbox({ email, pincode, city })];

  if (!isLocalHost()) {
    jobs.unshift(postNetlify(payload));
  }

  const results = await Promise.allSettled(jobs);
  if (results.every((result) => result.status === "rejected")) {
    throw new Error("Could not join the waitlist");
  }

  return { stored: true };
}
